<div class="container">
  <mat-icon fontSet="material-symbols-rounded" class="hero-icon">auto_awesome</mat-icon>
  <h1 class="title">{{ 'comingSoonTitle' | translate }}</h1>
  <p class="subtitle">{{ 'comingSoonSubtitle' | translate }}</p>
  <a mat-stroked-button [routerLink]="['/']">{{ 'backToHome' | translate }}</a>
</div>
